export default __webpack_public_path__ + "static/media/learning.2f52c0d5.svg";